import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './updateQuote.scss';
import { useAuth } from '@/lib/auth'
import { Loader } from '@/components/Loader/Loader';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { ReactComponent as Statusicon } from '@/assets/steam/funnel-frame.svg';
import { ReactComponent as LastCoverageIcon } from '@/assets/steam/last-coverage.svg';
import { ReactComponent as Calendericon } from '@/assets/steam/date-frame.svg';
import { ReactComponent as Coverageicon } from '@/assets/steam/coverage-frame.svg';
import { ReactComponent as ProductIcon } from '@/assets/steam/product.svg';
import { ReactComponent as ProductIconWithBg } from '@/assets/steam/product-with-bg.svg';
import Utils from '@/utils/util';
import Dropdown from 'react-bootstrap/Dropdown';
import { ReactComponent as DownIcon } from '@/assets/steam/down-icon.svg';
import { useGetUsersList } from '@/features/users/api/getProducts';
import { User } from '@/types';
import { useGetProductGroupList, useGetProductList } from '@/features/product/api/getProduct';
import { Product } from '@/features/product/types/indes';
import { ReactComponent as BookIcon } from '@/assets/steam/quotes.svg';
import { ReactComponent as BookFunnelIcon } from '@/assets/steam/book-funnel.svg';
import { ReactComponent as ProductFunnelicon } from '@/assets/steam/product-funnel.svg';
import { QUOTES_STATUS } from '@/utils/constants';
import { useUploadAudio } from '@/features/funnel/api/uploadAudio';
import { showNotification } from '@/utils/notificationUtils';
import { useGetQuotesUpdate, useUpdateQuote } from '../api/updateQuotes';
import { ReactComponent as Deleteicon } from '@/assets/steam/delete-red.svg';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const UpdateQuote: VFC<{
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    quoteDetails: any;
}> = ({ open, onClose, onConfirm, quoteDetails }) => {
    const { user } = useAuth();
    const item = quoteDetails;
    const [showData, setShowDetails] = useState(true);
    const [setSelectedFunnelStage, setSelectedFunnelState] = useState<any>({ name: '', id: null });
    const uploadPicture = useGetQuotesUpdate();
    const [uploadedPdf, setUploadedPdf] = useState<string>();
    const fileInputRef = useRef(null);
    const useCreateQuoteMutation = useUpdateQuote();

    const getQuotesStatus = (id: any) => {
        if (id === QUOTES_STATUS.REQUESTED) {
            return 'Requested'
        } else if (id === QUOTES_STATUS.IN_PROGRESS) {
            return 'In progress'
        } else if (id === QUOTES_STATUS.REJECTED) {
            return 'rejected'
        } else if (id === QUOTES_STATUS.COMPLETED) {
            return 'Uploaded'
        } else {
            ''
        }
    }

    const status = [
        { name: 'Requested', id: 1 },
        { name: 'Uploaded', id: 3 },
        { name: 'Rejected', id: 4 },
    ]
    useEffect(() => {
        if (item) {
            const getSttaus = status.filter((details: any) => Number(details.id) === Number(item.statusId))
            if (getSttaus && getSttaus.length > 0) {

                setSelectedFunnelState({ name: getSttaus[0].name, id: getSttaus[0].id })
            }
            if (item?.pdfLink) {
                setUploadedPdf(item?.pdfLink)
            }
        }

    }, [item])

    const createQuoteDetails = async () => {

        const res = await useCreateQuoteMutation.mutateAsync({
            id: quoteDetails?.id,
            pdfLink: uploadedPdf,
            statusId: uploadedPdf ? 3 : setSelectedFunnelStage?.id,

        });

        if (res) {
            setSelectedFunnelState({ name: '', id: null })
            setUploadedPdf('')
            onConfirm()
        }
    }

    const getAssignedSubjects = (assignedSubjectIds: string[], product: any) => {
        if (product && product.subject && assignedSubjectIds && assignedSubjectIds.length > 0) {
            const assignedSubjects = product.subject.filter((sub: any) =>
                assignedSubjectIds.includes(sub.id)
            );

            const subjectNames = assignedSubjects.map((sub: any) => sub.name);

            const firstSubject = subjectNames.slice(0, 1);
            const remainingCount = subjectNames.length - 1;
            const allSubjects = subjectNames.join(', ');


            return {
                firstSubject,
                remainingCount: remainingCount > 0 ? remainingCount : 0,
                allSubjects
            };
        }

        return { firstSubject: [], remainingCount: 0, allSubjects: [] };
    };


    const onFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = event.target.files as FileList;
        setUploadedPdf('');
        UploadInstitutePic(selectedFiles?.[0]);
    };

    const UploadInstitutePic = async (selectedFiles: any) => {
        if (selectedFiles && selectedFiles.type === 'application/pdf') {

            const formData = new FormData();
            formData.append('file', selectedFiles);
            formData.append('type', 'pdfFile');
            const response = await uploadPicture.mutateAsync({
                file: formData,
            });
            setUploadedPdf(response ? response.fileUrl : '');
        } else {
            showNotification({
                type: 'error',
                title: 'Incorrect file, please upload a PDF file.',
            });
        }
    };
    const onUploadImageHandler = () => {
        if (fileInputRef && fileInputRef.current) {
            (fileInputRef.current as any).click();
        }
    };


    const getAssignedClasses = (assignedClassIds: string[], product: any) => {
        if (product && product.subject && assignedClassIds && assignedClassIds.length > 0) {
            const allClasses = product.subject.reduce((classes: any[], subject: any) => {
                return classes.concat(subject.classes);
            }, []);


            const assignedClasses = allClasses.filter((cls: any) =>
                assignedClassIds.includes(cls.id)
            );
            const classNames = assignedClasses.map((cls: any) => cls.name);

            const firstClass = classNames.slice(0, 1);
            const remainingClassCount = classNames.length - 1;
            const allClassess = classNames.join(', ');

            return {
                firstClass,
                remainingClassCount: remainingClassCount > 0 ? remainingClassCount : 0,
                allClassess
            };
        }
        return { firstClass: [], remainingClassCount: 0, allClassess: [] };
    }

    const getQuantity = (item: any) => {
        if (item && item.length > 0) {

            return item.reduce((sum: any, product: any) => Number(sum) + Number(product.quantity), 0);
        } else {
            return 1
        }
    }

    const showUpdatebutton = () => {
        if (quoteDetails && Number(quoteDetails?.statusId) === 3) {
            return false;
        } else if (quoteDetails && Number(quoteDetails?.statusId) === 4) {
            return false;
        } else if (Number(quoteDetails?.statusId) === 1 && !uploadedPdf) {
            return true;
        } else {
            return false;
        }
    }



    const getContent = () => {
        return (
            <div className="view-quotes-dialog-content">
                <div className='details-panel mb-2  change-display'>
                    <div className='ddd-details'>
                        {/* <div className='tags'>Update Stage</div> */}
                        <div className='s-c-detail'>

                            <div className="user-first-last-div iscity-drp petsked-form">
                                <Dropdown className="new-figma-drop-down">
                                    <Dropdown.Toggle
                                        variant="success"
                                        className="drop-down-btn claim-width dropdown-toggle"
                                        id="dropdown-basic"
                                    >
                                        {setSelectedFunnelStage?.name ? setSelectedFunnelStage.name : 'Select stage'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="Duration-drop-down">
                                        {status?.map((item: any, index: any) => {
                                            return (
                                                <Dropdown.Item
                                                    key={index}
                                                    onClick={() => {
                                                        setSelectedFunnelStage.name = item.name
                                                        setSelectedFunnelStage.id = item.id
                                                        setSelectedFunnelState({ ...setSelectedFunnelStage })

                                                    }}
                                                    eventKey={item.name}
                                                >
                                                    <div className="menu-item-minutes">{item.name}</div>
                                                </Dropdown.Item>
                                            );
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                    {!uploadedPdf && <div className='upload-audio'>
                        <button className={`steam-button button-light`} onClick={onUploadImageHandler}>
                            Upload Pdf
                        </button>
                        <div className="form-group">
                            <input
                                type="file"
                                accept="PDF/*"
                                onChange={onFileSelect}
                                ref={fileInputRef}
                                hidden
                            />
                        </div>
                    </div>}

                    {uploadedPdf && (
                        <div className='upload-audio setDispaly'>
                            <button
                                className={`steam-button button-light`}
                                onClick={() => window.open(uploadedPdf, '_blank')}
                            >
                                PDF uploaded - {item.updatedAt ? Utils.formatAnyDate(item.updatedAt) : ''}
                            </button>
                            <Deleteicon onClick={() => { setUploadedPdf(''),   
                                                         setSelectedFunnelStage.name = 'Requested'
                                                        setSelectedFunnelStage.id = 1
                                                        setSelectedFunnelState({ ...setSelectedFunnelStage }) }} />
                        </div>
                    )}

                </div>


                {uploadPicture?.isLoading && <div className='mt-5'> <Loader text='Uploading pdf...' /> </div>}
                <div className='divider'></div>
                <div className='quotes-list'>
                    <div className='quotes-detail'>
                        <div className='quotes-title'>
                            <div className='quote-name'>

                                <div className='iconn'>
                                    <BookIcon />

                                </div>
                                <div className='datee'>
                                    <div className='bq'>
                                        {item.title}
                                    </div>
                                    <div className='dq'>
                                        {item.updatedAt ? Utils.formatAnyDate(item.updatedAt) : ''}
                                    </div>

                                </div>

                            </div>
                            <div className='quote-amount'>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip-id" className="service-provider-tooltip">
                                            <div className="service-name">
                                                ₹{Number(item.requestedPrice).toLocaleString('en-IN')}
                                            </div>
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className="tooltip-owner-name default"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Total Order Value <span>{Utils.convertDealSize(Number(item.requestedPrice))}</span>
                                    </span>
                                </OverlayTrigger>
                            </div>

                        </div>



                        <div className='quote-current-status'>

                            <div className='quote-type'>
                                <div className='type-title'>
                                    Institute Details
                                </div>
                                <div className='type-name display-flex'>
                                    {item?.institute?.name}, <div className='address-desc'>{item?.institute?.address}</div>
                                </div>

                            </div>

                             <div className='quote-type align-top'>
                                        <div className='type-title'>
                                        City and State
                                        </div>
                                        <div className='type-name'>
                                       {(item.institute && item.institute.city && item.institute.city.state) ? `${item.institute.city.name}, ${item.institute.city.state.name}` : ''}
                                        </div>
                                    </div>

                                     <div className='quote-type'>
                                        <div className='type-title'>
                                        Payment Percentage
                                        </div>
                                        <div className='type-name'>
                                        ADV: {item.advPercent || '-'} | PDA: {item.pdaPercent || '-'} | FNF: {item.fnfPercent || '-'}
                                        </div>
                                    </div>
                                    
                                    <div className='quote-type'>
                                        <div className='type-title'>
                                        FNF Timeline
                                        </div>
                                        <div className='type-name'>
                                        {item.fnfTimeline || '-'} {item.fnfTimeline ? 'Days after delivery' : ''}
                                        </div>
                                    </div>

                            <div className='quote-type'>
                                <div className='type-title'>
                                    Expected Order Date
                                </div>
                                <div className='type-name display-flex'>
                                    {item.deliveryTime ? Utils.formatAnyDate(item.deliveryTime) : ''}
                                </div>

                            </div>


                            <div className='quote-type'>
                                <div className='type-title'>
                                    Product Type
                                </div>
                                <div className='type-name'>
                                    <div className={`funnels-bg  change-bg`}>  {<ProductFunnelicon className='book-funnel-icon' />} Books </div>
                                </div>

                            </div>


                            <div className='quote-type'>
                                <div className='type-title'>
                                    Total Quantity
                                </div>
                                <div className='type-name'>
                                    {`${getQuantity(item.productGroups)} Units`}
                                </div>

                            </div>




                            {/* <div className='quote-type mt-3 align-top'>
                                <div className='type-title'>
                                    Payment Terms
                                </div>
                                <div className='type-name'>
                                    <div className='type-name'>
                                        {item.paymentTerms}
                                    </div>

                                </div>

                            </div> */}

                            <div className='quote-type mt-2 align-top'>
                                <div className='type-title'>
                                    Other Details
                                </div>
                                <div className='type-name'>
                                    <div className='type-name'>
                                        {item.otherDetails}
                                    </div>

                                </div>

                            </div>

                            {<div className='quote-type'>
                                <div className='type-title'>
                                    Total Products
                                </div>
                                <div className='type-name'>
                                    {item.productGroups && item.productGroups.length}  <DownIcon onClick={() => {

                                        if (showData) {
                                            setShowDetails(false);
                                            //setShowDetails(item.id)
                                        } else {
                                            setShowDetails(true);
                                        }
                                    }} />
                                </div>


                            </div>}

                            {showData && item && item?.productGroups && item?.productGroups.length > 0 && <div className='product-details-tab'>
                                <div className='product-header'>
                                    <div className='name'>
                                        Target Products
                                    </div>
                                    <div className='qty'>
                                        Qty
                                    </div>
                                    <div className='sub'>
                                        Subject
                                    </div>
                                    <div className='class'>
                                        Class
                                    </div>
                                    <div className='price'>
                                        Price
                                    </div>

                                </div>

                                {item && item?.productGroups && item?.productGroups.length > 0 && item?.productGroups.map((item: any, index: any) => {
                                    const { firstSubject, remainingCount, allSubjects } = getAssignedSubjects(item.subject, item.product);
                                    const { firstClass, remainingClassCount, allClassess } = getAssignedClasses(item.class, item.product);
                                    return (
                                        <div className='product-values' key={index}>
                                            <div className='name'>
                                                {item?.product?.name}
                                            </div>
                                            <div className='qty'>
                                                x{item.quantity}
                                            </div>
                                            <div className='sub'>
                                                {/* <div className="table-contact  font-valeu">
                                                    <div className='fix-width'>
                                                        {firstSubject}
                                                    </div>
                                                    {remainingCount > 0 && (
                                                        <span className='show-count'>
                                                            +{remainingCount}
                                                        </span>
                                                    )}
                                                </div> */}

                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip-id" className="service-provider-tooltip">
                                                                <div className="service-name">
                                                                    {allSubjects}
                                                            </div>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span
                                                        className="tooltip-owner-name default table-contact  font-vale"
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <div className='fix-width'>
                                                            {firstSubject}
                                                        </div>
                                                        {remainingCount > 0 && (
                                                            <span className='show-count'>
                                                                +{remainingCount}
                                                            </span>
                                                        )}
                                                    </span>
                                                </OverlayTrigger>
                                            </div>
                                            <div className='class'>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip-id" className="service-provider-tooltip">
                                                                <div className="service-name">
                                                                    {allClassess}
                                                                </div>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span
                                                        className="tooltip-owner-name default table-contact  font-vale"
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <div className='fix-width'>
                                                            {firstClass}
                                                        </div>
                                                        {remainingCount > 0 && (
                                                            <span className='show-count'>
                                                                +{remainingClassCount}
                                                            </span>
                                                        )}
                                                    </span>
                                                </OverlayTrigger>
                                                {/* <div className="table-contact font-valeu">
                                                    <div className='fix-width'>
                                                        {firstClass}
                                                    </div>
                                                    {remainingCount > 0 && (
                                                        <span className='show-count'>
                                                            +{remainingClassCount}
                                                        </span>
                                                    )}
                                                </div> */}
                                            </div>
                                            <div className='price'>
                                                {item?.price}
                                            </div>
                                        </div>
                                    )
                                })}




                            </div>}



                        </div>

                    </div>
                </div>


            </div>
        );
    };

    const getTitleDetail = (name?: string) => {
        if (name === 'followUpDate') {
            return 'Follow Up Date'
        } else if (name === 'funnelState') {
            return 'Funnel State'
        } else if (name === 'coverageDetails') {
            return 'Coverage Details'
        } else if (name === 'lastCoverageDate') {
            return 'Last Date Of Coverage'
        } else if (name === 'productDetails') {
            return 'Product'
        } else if (name === 'funnelHistory') {
            return 'Funnel'
        } else {
            return ''
        }
    }
    return (
        <>
            <Modal
                show={open}
                onHide={() => {
                    onClose(); setSelectedFunnelState({ name: '', id: null })
                    setUploadedPdf('')
                }}
                className={`steam-modal-dialog update-quotes-dialog`}
                size="sm"

            >
                <Modal.Header closeButton >
                    <div className="model-header-tab">
                        <div className="modal-header-title">
                            Upload Quotation
                        </div>
                        <div className="modal-header-desc">
                            {/* {'Lorem ipsum dolor sit amet, consectetur elit, sed'} */}
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body >{getContent()}</Modal.Body>
                <Modal.Footer>
                    <div className="btn-container display-flex">
                        <button
                            className={`steam-button button-dark display-flex `}
                            onClick={async () => {
                                createQuoteDetails();
                            }}
                            disabled={setSelectedFunnelStage?.id === 4 ? false : showUpdatebutton()}
                        >
                            <span> {'Update'}</span>
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};




export default UpdateQuote;
